
import facebookIcon from '../assets/images/facebook-icon.png';
import twitterIcon from '../assets/images/twitter-icon.png';
import youtubeIcon from '../assets/images/youtube-icon.png';
import instagramIcon from '../assets/images/instagram-icon.png';
import soundcloudIcon from '../assets/images/soundcloud-footer 24x24.png'
import tiktoktIcon from '../assets/images/TIKTOK-24X24-.png'

import facebookLogo from '../assets/images/facebook-logo.png';
import instagramLogo from '../assets/images/instagram-logo.png';
import tiktokLogo from '../assets/images/tiktok-logo.png';
import twitterLogo from '../assets/images/twitter-logo.png';
import youtubeLogo from '../assets/images/youtube-logo.png';
import spotifyLogo from '../assets/images/spotify-logo.png';
import soundcloudLogo from '../assets/images/soundcloud-logopng 90x60.png'
export function MainLogo() {

    const menuServiceLogo = (menuName) => {
        switch (menuName) {
            case "instagram":
                return "Insta";
            case "facebook":
                return "Facebook";
            case "tiktok":
                return "TikTok";
            case "twitter":
                return "Twitter";
            case "youtube":
                return "Youtube";
            case "soundcloud":
                return "SoundCloud";
            default:
                break;
        }
    }

    const MainLogo = (menuName) => {
        switch (menuServiceLogo(menuName)) {
            case "Insta":
                return <img src={instagramIcon} alt="Instagram icon" />
            case "Facebook":
                return <img src={facebookIcon} alt="Facebook icon" />
            case "TikTok":
                return <img src={tiktoktIcon} alt="TikTok icon" />
            case "Twitter":
                return <img src={twitterIcon} alt="Twitter icon" />
            case "Youtube":
                return <img src={youtubeIcon} alt="Youtube icon" />
            case "SoundCloud":
                return <img src={soundcloudIcon} alt="Soundcloud icon" />
            default:
                break;
        }
    }

    const HomeLogo = (menuName) => {
        switch (menuServiceLogo(menuName)) {
            case "Insta":
                return <img className="mx-auto my-5" src={instagramLogo} alt="Instagram icon" />
            case "Facebook":
                return <img className="mx-auto my-5" src={facebookLogo} alt="Facebook icon" />
            case "TikTok":
                return <img className="mx-auto my-5" src={tiktokLogo} alt="TikTok icon" />
            case "Twitter":
                return <img className="mx-auto my-5" src={twitterLogo} alt="Twitter icon" />
            case "Youtube":
                return <img className="mx-auto my-5" src={youtubeLogo} alt="Youtube icon" />
            case "SoundCloud":
                return <img className="mx-auto my-5" src={soundcloudLogo} alt="Soundcloud icon" />
            default:
                break;
        }
    }
    return {
        MainLogo,
        HomeLogo
    }
}